var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:arrow-up-line",
    clipPath: "url(#clip0_112_232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0247 8.48358C17.9792 8.22235 17.8318 7.98989 17.6149 7.83732C17.398 7.68475 17.1294 7.62457 16.8682 7.67L8.98651 9.04194C8.85532 9.06243 8.72952 9.10885 8.61646 9.17848C8.50339 9.24811 8.40533 9.33956 8.32799 9.4475C8.25065 9.55543 8.19558 9.67769 8.16599 9.80714C8.1364 9.93658 8.13289 10.0706 8.15566 10.2014C8.17844 10.3323 8.22703 10.4572 8.29862 10.5691C8.3702 10.6809 8.46334 10.7774 8.57261 10.8528C8.68187 10.9283 8.80507 10.9812 8.93501 11.0085C9.06495 11.0359 9.19903 11.0371 9.32943 11.012L14.8328 10.0541L7.21318 20.8854C7.06058 21.1023 7.0004 21.371 7.04588 21.6323C7.09136 21.8935 7.23878 22.1261 7.4557 22.2787C7.67262 22.4313 7.94127 22.4914 8.20256 22.446C8.46384 22.4005 8.69636 22.2531 8.84896 22.0361L16.4686 11.2048L17.4266 16.7082C17.476 16.9657 17.6246 17.1935 17.8404 17.3425C18.0561 17.4915 18.3218 17.5498 18.5801 17.5048C18.8384 17.4598 19.0688 17.3152 19.2215 17.1021C19.3742 16.8889 19.4371 16.6243 19.3966 16.3653L18.0247 8.48358Z",
    fill: "#4F6BFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLine);
export default __webpack_public_path__ + "static/media/arrow_up_line.0f5cdddb4d286b5c7b5f51ebbf0e87b5.svg";
export { ForwardRef as ReactComponent };